import React, { useState } from "react";
import { Dropdown, Spinner } from "react-bootstrap";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { weekendApi } from "../../../../api/weekend";
import { WMSchedule, WMScheduleInput } from "../../../../types/scheduling/weekend";
import { updateWMSchedulesCache } from "../../../../query/meetings";
import { HGBugsnagNotify } from "../../../../helpers/bugsnag";
import { MaxSongNumber } from "../../../../helpers/util";
import { canUpdateWeekendSchedules } from "../wm_common";

interface SongNumberDropdownProps {
  schedule: WMSchedule;
  langGroupId: number;
}

export const SongNumberDropdown: React.FC<SongNumberDropdownProps> = ({ schedule, langGroupId }) => {
  const [saving, setSaving] = useState(false);
  const queryClient = useQueryClient();

  const setScheduleMutation = useMutation({
    mutationFn: (wmsInput: WMScheduleInput) => weekendApi.setSchedule(wmsInput, langGroupId),
  });

  const assignSong = async (songNumber: number | null) => {
    setSaving(true);
    const input: WMScheduleInput = {
      ...schedule,
      opening_song: songNumber,
      temp_cong: schedule.temp_cong?.id ?? 0,
      speaker: schedule.speaker.id,
      speaker2: schedule.speaker2 ?? null,
      public_talk: schedule.public_talk?.number ?? 0,
      talk_mod: schedule.talk_mod ?? "",
      wt_conductor: schedule.wt_conductor ?? null,
      openprayer: schedule.openprayer ?? null,
      closeprayer: schedule.closeprayer ?? null,
    };
    try {
      const resp = await setScheduleMutation.mutateAsync(input);
      updateWMSchedulesCache(queryClient, langGroupId, resp);
    } catch (err: any) {
      console.error("wm crh: error setting song", err);
      HGBugsnagNotify("setWMSong", err);
    } finally {
      setSaving(false);
    }
  };

  const songNumbers = Array(MaxSongNumber).fill(0);

  return (
    <Dropdown className="dropdown-bounded">
      <Dropdown.Toggle variant="secondary" disabled={!canUpdateWeekendSchedules() || saving}>
        {saving ? <Spinner animation="border" size="sm" /> : schedule.opening_song?.number || " "}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {!!schedule.opening_song && <Dropdown.Item onClick={() => assignSong(null)}>&nbsp;</Dropdown.Item>}
        {songNumbers.map((_, i) => (
          <Dropdown.Item key={i} onClick={() => assignSong(i + 1)}>
            {i + 1}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};
